import { connect } from 'react-redux';
import { ParticipantViewModel, ParticipantVirtualGraduationState } from 'stageclip-common';
import get from 'lodash/get';

import { ClippingPlatformState } from 'store/clippingPlatformState';
import { getItem } from 'store/selectors';
import { createModalCloseAction, createModalOpenAction } from 'actions/modalActions';
import { SimpleModalId } from 'constants/modalId';
import { normalizeParticipant } from 'api/normalizers/participantNormalizers';
import { createEditParticipant } from 'api/participants/participants.actions';
import { InternalActionTypes } from 'constants/actionTypes';
import { ReviewModalContent } from './ReviewModalContent';
import { callApi } from 'helpers/callApi/callApi';
import { Asset, ReviewModalContentOwnProps } from './ReviewModal.types';

const mapStateToProps = (
  state: ClippingPlatformState,
  {
    data: {
      participant: { eventId, id },
    },
  }: ReviewModalContentOwnProps,
) => {
  const event = getItem(state.entities.events, eventId);
  const participant = getItem(state.entities.participants, id);

  return { eventDeadlineDate: get(event, 'deadlineDate'), participant };
};

const defaultOnSuccessAction = (payload: ParticipantViewModel) => ({
  type: InternalActionTypes.ParticipantReviewStatusUpdated,
  eventId: payload.eventId,
  result: normalizeParticipant(payload),
});

const mapDispatchToProps = (dispatch: Function, { onSuccessAction = defaultOnSuccessAction }: any) => ({
  updateParticipantVGState: (
    id: string,
    state: ParticipantVirtualGraduationState.Accepted | ParticipantVirtualGraduationState.Rejected,
  ) => {
    callApi<ParticipantViewModel>({
      action: () =>
        dispatch(
          createEditParticipant({
            id,
            // @ts-ignore
            virtualGraduation: { state },
          }),
        ),
      onSuccess: ({ payload }) => {
        dispatch(createModalCloseAction(SimpleModalId.ParticipantReview));
        dispatch(onSuccessAction(payload));

        dispatch({
          type:
            state === ParticipantVirtualGraduationState.Accepted
              ? InternalActionTypes.ParticipantVirtualGraduationAccepted
              : InternalActionTypes.ParticipantVirtualGraduationRejected,
        });
      },
    });
  },
  openDeleteModal: (data: { asset: Asset; participantId: ParticipantViewModel['id'] }) =>
    dispatch(createModalOpenAction(SimpleModalId.DeleteVGParticipantAsset, data)),
});

export const ReviewModalContentContainer = connect(mapStateToProps, mapDispatchToProps)(ReviewModalContent);
